import styled, { css, useTheme } from "styled-components";
import AntSegmented from "antd/es/segmented";
import React, { CSSProperties } from "react";
import { PlatformType } from "@shared/types";
import { CrowLogo, Discord, Telegram } from "common/Icons/Icons";
import { AccountTypeButton } from "features/onboarding/methodSettings/signalsGroup/connectExternalAccount/AccountTypeButtons.tsx";

interface WhopChannelTypeTabsProps {
  platformType?: PlatformType;
  setPlatformType: (platformType: PlatformType) => void;
  style?: CSSProperties;
  iconStyle?: CSSProperties;
}

const WhopChannelTypeTabs = ({
  platformType,
  setPlatformType,
  style,
  iconStyle,
}: WhopChannelTypeTabsProps) => {
  const { isNewLook } = useTheme();

  if (isNewLook) {
    const options = [
      {
        type: PlatformType.TELEGRAM,
        name: "Telegram",
        icon: <StyledTelegram style={NEW_LOOK_ICON_STYLE} />,
      },
      {
        type: PlatformType.DISCORD,
        name: "Discord",
        icon: <StyledDiscord style={NEW_LOOK_ICON_STYLE} />,
      },
      {
        type: PlatformType.CORNIX,
        name: "Cornix",
        icon: <StyledCornix style={NEW_LOOK_ICON_STYLE} />,
      },
    ];
    // The shared segmented control (styles/newLook.scss), like the app's
    // other small toggles.
    return (
      <Segmented<PlatformType>
        style={style}
        value={platformType}
        onChange={(value) => setPlatformType(value)}
        options={options.map((option) => ({
          value: option.type,
          label: (
            <SegmentLabel>
              {option.icon}
              {option.name}
            </SegmentLabel>
          ),
        }))}
      />
    );
  }

  return (
    <Wrapper style={style}>
      <AccountTypeButton
        name="Telegram"
        icon={<StyledTelegram style={iconStyle} />}
        onClick={() => setPlatformType(PlatformType.TELEGRAM)}
        isSelected={platformType === PlatformType.TELEGRAM}
      />
      <AccountTypeButton
        name="Discord"
        icon={<StyledDiscord style={iconStyle} />}
        onClick={() => setPlatformType(PlatformType.DISCORD)}
        isSelected={platformType === PlatformType.DISCORD}
      />
      <AccountTypeButton
        name="Cornix"
        icon={<StyledCornix style={iconStyle} />}
        onClick={() => setPlatformType(PlatformType.CORNIX)}
        isSelected={platformType === PlatformType.CORNIX}
      />
    </Wrapper>
  );
};

export default WhopChannelTypeTabs;

const NEW_LOOK_ICON_STYLE = { width: 16, height: 16, fontSize: 16 };

const Segmented = styled(AntSegmented)`
  align-self: flex-start;
  .ant-segmented-item-label {
    min-height: 34px;
    line-height: 34px;
    padding: 0 16px;
    font-size: 13.5px;
  }
` as unknown as typeof AntSegmented;
const SegmentLabel = styled.span`
  display: inline-flex;
  align-items: center;
`;
const Wrapper = styled.div`
  display: flex;
  column-gap: 8px;
`;
const iconStyles = css`
  margin-right: 8px;
`;
const StyledCornix = styled(CrowLogo)`
  ${iconStyles}
`;
const StyledTelegram = styled(Telegram)`
  ${iconStyles}
`;
const StyledDiscord = styled(Discord)`
  ${iconStyles}
`;
